import { Clock, AlertTriangle, FileText } from 'lucide-react';

interface ActionItemProps {
  title: string;
  count: number;
  onClick?: () => void;
}

// Fonction pour déterminer l'icône et la couleur selon le titre
const getActionIcon = (title: string) => {
  if (title.toLowerCase().includes('hors délais')) {
    return {
      icon: <Clock className="h-5 w-5 text-orange-500" />,
      bgColor: 'bg-orange-500/10'
    };
  }
  if (title.toLowerCase().includes('fraude')) {
    return {
      icon: <AlertTriangle className="h-5 w-5 text-red-500" />,
      bgColor: 'bg-red-500/10'
    };
  }
  if (title.toLowerCase().includes('feedback') || title.toLowerCase().includes('candidat')) {
    return {
      icon: <FileText className="h-5 w-5 text-blue-500" />,
      bgColor: 'bg-blue-500/10'
    };
  }
  // Par défaut
  return {
    icon: <FileText className="h-5 w-5 text-gray-500" />,
    bgColor: 'bg-gray-500/10'
  };
};

export const ActionItem = ({ title, count, onClick }: ActionItemProps) => {
  const { icon, bgColor } = getActionIcon(title);
  
  return (
    <div 
      className="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer group"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className={`p-2 ${bgColor} rounded-lg group-hover:scale-110 transition-transform`}>
          {icon}
        </div>
        <span className="text-gray-800 font-medium text-sm font-['Bricolage_Grotesque']">
          {title}
        </span>
      </div>
      <div className="flex items-center justify-center min-w-[24px] h-6 px-2 bg-primary/10 rounded-md">
        <span className="text-primary text-sm font-semibold font-['Bricolage_Grotesque']">
          {count}
        </span>
      </div>
    </div>
  );
};